export default __webpack_public_path__ + "static/media/Prototype-Screen.adbef430.png";